export default __webpack_public_path__ + "static/media/bg17.96515d97.jpg";